// eslint-disable-next-line import/prefer-default-export
export const QUICKLINKS_OVERLAY_KEY = 'quicklinks_overlay';
export const QUICKLINKS_LOGOUT_TIMEOUT = 1000;
